import { useState, useEffect } from "react";
import { announcementsApi } from "@/lib/api";
import { Megaphone, WarningCircle } from "@phosphor-icons/react";
import { format } from "date-fns";

export default function AnnouncementsFeed() {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    announcementsApi.list().then(({ data }) => { setAnnouncements(data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  if (loading) return <div className="space-y-3">{[1,2].map(i => <div key={i} className="h-24 bg-muted rounded-xl animate-pulse" />)}</div>;

  return (
    <div className="space-y-4" data-testid="announcements-feed">
      <h2 className="font-heading text-2xl font-semibold tracking-tight">Announcements</h2>
      {announcements.length === 0 ? (
        <div className="text-center py-16 text-muted-foreground">
          <Megaphone className="w-10 h-10 mx-auto mb-3 opacity-30" />
          <p>No announcements yet</p>
        </div>
      ) : announcements.map((a) => (
        <div key={a.id} className="bg-card border border-border rounded-xl p-5 shadow-sm" data-testid={`announcement-${a.id}`}>
          <div className="flex items-center gap-2 mb-2">
            {a.priority === "urgent" && <WarningCircle className="w-4 h-4 text-accent" weight="fill" />}
            <h3 className="font-heading font-semibold text-foreground">{a.title}</h3>
          </div>
          <p className="text-sm text-foreground/80 leading-relaxed whitespace-pre-line">{a.body}</p>
          <p className="text-xs text-muted-foreground mt-3">{a.createdAt ? format(new Date(a.createdAt), "dd MMM yyyy, h:mm a") : ""}</p>
        </div>
      ))}
    </div>
  );
}
